export default __webpack_public_path__ + "static/media/logo.dce1f99f.png";